module.exports = __webpack_public_path__ + "img/Latvia.1ab1ff41.png";